module.exports = __webpack_public_path__ + "img/okupid.ccfe075.png";